namespace Matrix {
    export class GridEditingHelper extends Serenity.Widget<any> {

        grid: Slick.Grid;
        leftRightNav: boolean;

        public updateTabOrders(e?: any) {
            if (!this.grid)
                return;

            var vp = this.grid.getViewport(undefined, undefined);
            var cols = this.grid.getColumns();
            var tabidx = 0;
            for (var row = vp.top; row <= vp.bottom; row++) {
                for (var i = 0; i < cols.length; i++) {
                    $(this.grid.getCellNode(row, i)).find(':input').each((x, e) => e.setAttribute('tabindex', (++tabidx).toString()));
                }
            }
        }

        constructor(element: JQuery, grid: Slick.Grid, leftRightNav?: boolean) {
            super(element, null);

            this.grid = grid;
            this.leftRightNav = leftRightNav || false;

            var updateTimeout = 0;
            // fix tab order issue due to slickgrid scroll virtualization
            this.grid.onViewportChanged.subscribe(() => {
                if (updateTimeout)
                    window.clearTimeout(updateTimeout);
                updateTimeout = window.setTimeout(() => {
                    this.updateTabOrders();
                    updateTimeout = 0;
                }, 500);
            });

            this.updateTabOrders();

            this.element.on('keydown.' + this.uniqueName, ':input', e => {
                var tr = $(e.target).closest('.slick-row');
                if (!tr.length)
                    return;

                var cp = grid.getCellFromEvent(e);

                if (e.which == 40 || e.which == 38) {
                    // unfortunately this doesn't work for selects in firefox etc.
                    if ($(e.target).is('select')) {
                        return;
                    }

                    for (var i = 1; i < 10; i++) {
                        var next = grid.getCellNode(cp.row + (e.which == 40 ? i : -i), cp.cell);
                        if (!next)
                            continue;
                        var input = $(next).find(':input');
                        if (input.length) {
                            input.focus();
                            window.setTimeout(() => input.select(), 0);
                            return;
                        }
                    }
                }

                if ((e.which == 37 || e.which == 39) && this.leftRightNav) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    for (var i = 1; i < 10; i++) {
                        var next = grid.getCellNode(cp.row, (e.which == 39 ? i : -i) + cp.cell);
                        if (!next)
                            continue;
                        var input = $(next).find(':input');
                        if (input.length) {
                            input.focus();
                            window.setTimeout(() => input.select(), 0);
                            return;
                        }
                    }
                }

                return;
            });
        }

        cleanup() {
            this.element.find('.slick-viewport').off("." + this.uniqueName);
        }

        destroy() {
            this.cleanup();
            this.grid && this.grid.onViewportChanged.clear();
            this.grid = null;
            super.destroy();
        }
    }
}